import { PurchaseOrderLineItemRecord } from '~/modules/trade/types/purchaseOrder';

export const validateLineItems = (lineItems: PurchaseOrderLineItemRecord[]) =>
  lineItems.reduce(
    (acc, lineItem) => {
      if (!lineItem.itemId) {
        acc[`lineItem|${lineItem.id}|itemId`] = 'required';
      }
      if (!lineItem.quantity) {
        acc[`lineItem|${lineItem.id}|weights.net`] = 'required';
      }
      return acc;
    },
    {} as Record<string, string>,
  );
